// removed by extract-text-webpack-plugin
module.exports = {"DurexIcon":"DurexIcon__DurexIcon__36N0F","iconImage":"DurexIcon__iconImage__1nyq0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DurexIcon/DurexIcon.css
// module id = 514
// module chunks = 0